<div class="field-palette">
	<!-- Header -->
	<div class="palette-header">
		<h3 class="palette-title" matTooltip="Drag fields onto the canvas to build your form">
			<mat-icon>widgets</mat-icon>
			<span>Fields</span>
		</h3>
	</div>

	<!-- Search Bar -->
	<div class="palette-search">
		<mat-form-field appearance="outline" class="search-field">
			<mat-label>Search fields...</mat-label>
			<input
				matInput
				[(ngModel)]="searchTerm"
				placeholder="Type to search"
				matTooltip="Search for fields by name or description"
			/>
			<button mat-icon-button matSuffix *ngIf="searchTerm" (click)="clearSearch()" matTooltip="Clear search">
				<mat-icon>close</mat-icon>
			</button>
			<mat-icon matPrefix>search</mat-icon>
		</mat-form-field>
	</div>

	<!-- Categories -->
	<div class="palette-categories">
		<mat-accordion multi>
			<mat-expansion-panel
				*ngFor="let category of filteredCategories"
				[expanded]="category.expanded"
				class="category-panel"
			>
				<mat-expansion-panel-header
					[matTooltip]="'Click to ' + (category.expanded ? 'collapse' : 'expand') + ' ' + category.label"
				>
					<mat-panel-title class="category-title">
						<mat-icon>{{ category.icon }}</mat-icon>
						<span>{{ category.label }}</span>
						<span
							class="field-count"
							matTooltip="{{ category.fields.length }} field{{
								category.fields.length !== 1 ? 's' : ''
							}} available"
							>{{ category.fields.length }}</span
						>
					</mat-panel-title>
				</mat-expansion-panel-header>

				<!-- Field Items -->
				<div
					class="field-items"
					cdkDropList
					[cdkDropListSortingDisabled]="true"
					[id]="'palette-' + category.name"
				>
					<div
						*ngFor="let field of category.fields"
						class="field-item"
						cdkDrag
						[cdkDragData]="field"
						(cdkDragStarted)="onDragStarted($event, field)"
						[matTooltip]="'Drag to add: ' + field.description"
					>
						<div class="field-item-content">
							<mat-icon class="field-icon">{{ field.icon }}</mat-icon>
							<div class="field-info">
								<div class="field-label">{{ field.label }}</div>
								<div class="field-description">{{ field.description }}</div>
							</div>
							<mat-icon class="drag-handle" matTooltip="Drag to add field">drag_indicator</mat-icon>
						</div>
					</div>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
	</div>

	<!-- Empty State -->
	<div class="empty-state" *ngIf="filteredCategories.length === 0">
		<mat-icon>search_off</mat-icon>
		<p>No fields found</p>
		<p class="empty-subtitle">Try a different search term</p>
	</div>
</div>
